module.exports = "/packs/014-c6075bd104b8eb5233673aa3f1af1680.jpg";